import React from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import { useAccount } from 'wagmi'

import { trpc } from '~/utils/trpc'
import { StatusContainer } from './common'

const styles = {
  color: {
    textTopColor: 'black',
    textBottomColor: 'black',
    background: 'radial-gradient(100% 100% at 50% 0%, #94FE93 0%, #7DF8D5 100%)',
  },
  blackAndWhite: {
    textTopColor: '#9c9da8',
    textBottomColor: 'white',
    background: '#26262b',
  },
}

function NewArtStatusCell() {
  const { address: walletAddress } = useAccount()
  const { data: submissions } = trpc.useQuery(
    ['submissions.getUnreadSubmissions', { walletAddress: walletAddress! }],
    { enabled: !!walletAddress },
  )

  console.log('submissions', submissions)

  const text = submissions?.length ? 'New submissions' : 'New art submissions'

  const style = submissions?.length ? styles.color : styles.blackAndWhite
  const { textTopColor, textBottomColor, background } = style

  return (
    <Link passHref href={{ pathname: '/submissions' }}>
      <NewArtContainer as={'a'} style={{ background, textDecoration: 'none' }}>
        <MiddleCell>
          <MiddleText style={{ color: textTopColor }}>{submissions?.length ?? '-'}</MiddleText>
          <BottomText style={{ color: textBottomColor }}>{text}</BottomText>
        </MiddleCell>
      </NewArtContainer>
    </Link>
  )
}

const NewArtContainer = styled(StatusContainer)`
  width: 312px;
  justify-content: center;
  align-items: center;

  background: #26262b;
  box-shadow: 0px 1.49px 4.0375px rgba(255, 255, 255, 0.2), inset 0px 8px 12px rgba(0, 0, 0, 0.25);
`

const MiddleCell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 7;
  gap: 2px;
`
const MiddleText = styled.div`
  font-weight: 900;
  font-size: 96px;
  color: #9c9da8;
  text-align: center;
`

const BottomText = styled.div`
  font-weight: 700;
  font-size: 20px;
  color: white;
  text-align: center;
`

export default NewArtStatusCell
